<template>
    <span>
        <v-icon
            v-if="productVariant?.icon"
            v-tooltip:bottom="{text: productVariant.name, disabled: showLabel}"
            start
            size="x-small"
        >
            {{ productVariant.icon }}
        </v-icon>
        <span v-if="productVariant && showLabel" class="ms-1">{{ productVariant.name }}</span>
    </span>
</template>

<script setup lang="ts">
    const props = defineProps<{
        product: any
        showLabel?: boolean
    }>()
    const {getProductVariantById} = useProductVariants()
    const productVariant = computed(() => getProductVariantById(props.product.productVariantId))
</script>
